import React from 'react';
import { IIconProps } from '../IIconProps';

export const ClientIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" className={iconClass} fill="none">
			{title && <title>{title}</title>}
			<path
				d="M8.25806 12.5C10.3416 12.5 12.2038 12.8828 13.5264 13.4807C14.8951 14.0995 15.5 14.8516 15.5 15.5V17.5H0.5V15.5C0.5 15.2003 0.65293 14.8621 1.03369 14.4999C1.41434 14.1378 1.98589 13.7897 2.71692 13.4871C4.17643 12.8829 6.17422 12.5 8.25806 12.5Z"
				stroke="currentColor"
			/>
			<path
				d="M14.0553 17.5H19.0898H23.4997V15.8333C23.4997 14.5447 20.2912 13.5 16.3337 13.5C15.5293 13.5 14.756 13.5431 14.0342 13.6227"
				stroke="currentColor"
			/>
			<path
				d="M11.5 6.5C11.5 8.15685 10.1569 9.5 8.5 9.5C6.84315 9.5 5.5 8.15685 5.5 6.5C5.5 4.84315 6.84315 3.5 8.5 3.5C10.1569 3.5 11.5 4.84315 11.5 6.5Z"
				stroke="currentColor"
			/>
			<path
				d="M18.5 8.5C18.5 9.60457 17.6046 10.5 16.5 10.5C15.3954 10.5 14.5 9.60457 14.5 8.5C14.5 7.39543 15.3954 6.5 16.5 6.5C17.6046 6.5 18.5 7.39543 18.5 8.5Z"
				stroke="currentColor"
			/>
		</svg>
	);
};
